import { render } from "./mobileMoney.vue?vue&type=template&id=0d190205&scoped=true"
import script from "./mobileMoney.vue?vue&type=script&lang=js"
export * from "./mobileMoney.vue?vue&type=script&lang=js"

import "./mobileMoney.vue?vue&type=style&index=0&id=0d190205&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d190205"]])

export default __exports__